module.exports = __webpack_public_path__ + "img/GAME_OXQUIZ.bb5eea8b.png";